<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="820" v-model="dialog"
    content-class="commission-tree" v-if="$canRoute('commission-tree') === 1">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :ripple="false" v-bind="attrs" v-on="on" tile elevation="0" class="custom-btn mr-0 px-2" height="39"
        color="#039de9" width="100%">
        Add New Commission
      </v-btn>
    </template>
    <v-stepper v-model="currentStep" class="password-stepper admin-password-stepper">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row dense>
              <v-card class="rounded-0 pa-10" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-card-title class="pb-1 pt-0 text-left justify-start pl-3">
                  Set New Commission
                </v-card-title>
                <v-card-subtitle class="mt-0 pl-3 pb-4 text--ash">
                  If You Don’t Understand this Commission Setting or How You Can
                  Split Amount to all Levels or Need More Information? Click to
                  see
                  <router-link class="text-decoration-underline text--green" router to="/">Ideal Commission
                    Mode</router-link>
                </v-card-subtitle>
                <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <fieldset class="mb-0">
                        <legend>Account Type</legend>
                        <v-select solo :items="formattedAccountTypes" item-text="display" item-value="id"
                          v-model="selectedAccountType" append-icon="mdi-chevron-down" label="Click to Select"
                          class="custom-select" hide-details></v-select>
                      </fieldset>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="6">
                      <fieldset class="mb-0">
                        <legend>Currency Group</legend>
                        <v-select solo :items="formattedCurrencyGroups" item-text="title" item-value="id"
                          v-model="selectedCurrencyGroup" append-icon="mdi-chevron-down" label="Currency Group"
                          class="custom-select" hide-details></v-select>
                      </fieldset>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12">
                      <fieldset class="mb-0">
                        <legend>Commission Amount $</legend>
                        <v-text-field label="20" v-model="commission_amount" type="number" single-line solo hide-details
                          class="custom-select"></v-text-field>
                      </fieldset>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card-actions>
                  <v-row>
                    <v-col cols="6">
                      <v-btn block @click="dialog = false" :ripple="false" tile elevation="0" color="#FF567F" class="custom-btn">
                        Cancel
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn @click="handleSplitCommission" block :ripple="false" tile elevation="0" class="custom-btn"
                        color="#039de9">
                        Split Commission
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-row dense>
            <v-card class="deposit-form create-account-form"
              :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
              <v-row dense>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-1 pt-0 justify-space-between font-weight-bold pl-3">
                    <span>Custom Commission Split</span>
                    <a target="_blank" class="text--green text-decoration-underline" href="https://www.youtube.com/watch?v=oRDRfikj2z8&t=1s">
                      See Video
                    </a>
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-4 text--ash tree-commission-label">
                    <span style="text-transform: capitalize">{{ formatedAccountTypeName }}</span>
                    <span style="text-transform: capitalize">{{ formatedCurrencyGroupName }}</span>
                    <span>L 1 - {{ `L ${levelCounts}` }}</span>
                    <span>$ {{ commission_amount }}</span>
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <commission-split-table :splitData="splited_data" :levelCounts="Number(levelCounts)"
                      :tutorial="addcommissionconfig?.tutorial" v-model="splited_data"
                      @update:splitData="updateSplitData"></commission-split-table>
                  </v-card>
                  <v-card-actions>
                    <v-row>
                      <v-col cols="6">
                        <v-btn block @click="handleCancel" :ripple="false" tile elevation="0" class="custom-btn"
                          color="#FF567F">
                          Cancel
                        </v-btn>
                      </v-col>
                      <v-col cols="6">
                        <v-btn @click="handleSubmit" block :ripple="false" tile elevation="0" class="custom-btn"
                          color="#039de9">
                          Submit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-row>
            </v-card>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import { COMMISSIONTREE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import CommissionSplitTable from './CommissionSplitTable.vue';
import toast from "@/services/Notification";

export default {
  components: { CommissionSplitTable },

  data() {
    return {
      dialog: false,
      currentStep: 1,
      selectedAccountType: null,
      selectedCurrencyGroup: null,
      commission_amount: 0,
    };
  },

  computed: {
    ...mapState("commissiontree", ["levelCounts", "tierCounts", "accountTypes", "currencyGroups", "splited_data", "addcommissionconfig"]),
    ...mapState("admins", ["loggedAdmin"]),

    formattedAccountTypes() {
      return this.accountTypes
        ? this.accountTypes.map(type => ({
          id: type?.id,
          display: `${type?.account_type_display?.toUpperCase()} (${type?.LiveDemo} ${type?.Mt4Mt5})`,
        }))
        : [];
    },

    formatedAccountTypeName() {
      return this.accountTypes ? this.accountTypes?.find(account => account?.id ===
        this.selectedAccountType)?.account_type_display : null
    },

    formatedCurrencyGroupName() {
      return this.currencyGroups ? this.currencyGroups?.find(group => group?.id ===
        this.selectedCurrencyGroup)?.title : null
    },

    formattedCurrencyGroups() {
      return this.currencyGroups ? this.currencyGroups.map(type => ({
        id: type?.id,
        title: type?.title,
      })) : [];
    },
  },

  methods: {
    ...mapActions("commissiontree", [
      COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS,
      COMMISSIONTREE__ACTIONS.SPLITTOTALCOMMISSION,
      COMMISSIONTREE__ACTIONS.ADDCOMMISSIONSETTINGSCONFIG,
      COMMISSIONTREE__ACTIONS.ADDCOMMISSIONTREE,
    ]),

    handleSplitCommission() {
      this[COMMISSIONTREE__ACTIONS.SPLITTOTALCOMMISSION]({
        totalCommission: this.commission_amount,
        finalLevel: this.levelCounts
      });
      setTimeout(() => {
        this.currentStep = 2
      }, 100)
    },

    handleCancel() {
      this.dialog = false
      this.selectedAccountType = null;
      this.selectedCurrencyGroup = null;
      this.commission_amount = 0;
      this.currentStep = 1
    },

    updateSplitData(newData) {
      this.splited_data = { ...newData };
    },

    async handleSubmit() {
      try {
        await this[COMMISSIONTREE__ACTIONS.ADDCOMMISSIONTREE]({
          account_type: this.selectedAccountType,
          currency_group: this.selectedCurrencyGroup,
          total_commission: Number(this.commission_amount),
          split_commission: this.splited_data
        })
      } catch(error) {
        console.log(error);
      } finally {
        this.handleCancel();
        this.dialog = false;
      }
    }
  },

  async mounted() {
    this[COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS]();
    this[COMMISSIONTREE__ACTIONS.ADDCOMMISSIONSETTINGSCONFIG]();
    this[COMMISSIONTREE__ACTIONS.SPLITTOTALCOMMISSION]({
      totalCommission: this.commission_amount,
      finalLevel: this.levelCounts
    });
  },
};
</script>
